import React from 'react';
import { styled } from '@tmap/mmm-style-guide/src/styled';

const StyledIFrame = styled(
  'iframe',
  { shouldForwardProp: (p) => p !== 'breakpointHeights' },
)(({ theme, breakpointHeights }) => ({
  border: 'none',
  height: '300px',
  [theme.breakpoints.down('lg')]: {
    height: breakpointHeights.lg,
  },
  [theme.breakpoints.down('md')]: {
    height: breakpointHeights.md,
  },
  [theme.breakpoints.down('sm')]: {
    height: breakpointHeights.sm,
  },
  [theme.breakpoints.down('xs')]: {
    height: breakpointHeights.xs,
  },
  width: '1px',
  minWidth: '100%',
}));

function IFrame(props) {
  const {
    url, xs, sm, md, lg,
  } = props;
  return (
    <StyledIFrame
      src={url}
      breakpointHeights={{
        xs, sm, md, lg,
      }}
    />
  );
}

export default IFrame;
